import { LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT, SET_MFA_DATA, RESET_MFA, UPDATE_OTP_TOKEN } from '../constants/actions'; 
import { UserModel } from '../model/UserModel';
import { dispatch } from '../utils/generalUtils';

export function throwError(text: string) {
    return dispatch({
        type: LOGIN_ERROR,
        text
    });
}

export function login(userInfo: UserModel) {
    return dispatch({
        type: LOGIN_SUCCESS,
        userInfo
    });
}

export function logout() {
    return dispatch({
        type: LOGOUT,
    });
}

export function setMfaData(mfaData: any) {
    return dispatch({
        type: SET_MFA_DATA,
        mfaData
    });
}

export function resetMfa() {
    return dispatch({
        type: RESET_MFA,
    });
}

export function updateOtpToken(otpToken: string) {
    return dispatch({
        type: UPDATE_OTP_TOKEN,
        otpToken
    });
}
